<template>
    <div>
        <div class="join-us" v-if="data">
            <h1>加入學會</h1>
            <div class="content" v-html="data.joinus"></div>
            <div class="footer">
                <div v-if="data.cansignup" class="btn-join" @click="joinAssociation"><div class="lds-ring" v-if="joinLoading"><div></div><div></div><div></div><div></div></div>{{joinLoading ? '正在提交...' : '申請加入學會'}}</div>
            </div>
        </div>
        <loading v-if="loading"/>
    </div>
</template>

<script>
    import Loading from '../components/Loading'
    export default {
        components: {
            Loading,
        },
        data(){
            return {
                loading: false,
                data: null,
                joinLoading: false,
            }
        },
        mounted: function(){
            this.onRefresh()
        },
        methods: {
            joinAssociation: function(){
                if(this.joinLoading) return
                if(!this.$store.getters.userInfo) {
                    this.joinLoading = true
                    this.$message.config({
                        top: `100px`,
                    })
                    this.$message.loading('請稍候...', 1).then(() => this.$message.warning('未登錄，請先登錄', 1.5))
                    setTimeout(() => {
                        document.querySelector('#login').click()
                        this.joinLoading = false
                        this.$message.config({})
                    }, 2500)
                    return
                }
                this.joinLoading = true
                this.$store.dispatch('joinAssociation', {
                    associationid: 4,
                    clientid: this.$store.getters.userInfo.clientid,
                }).then(d=>{
                    this.joinLoading = false
                    this.$message.success('加入學會成功！')
                }).catch(error=>{
                    this.joinLoading = false
                    this.$message.warning(error)
                })
            },
            onRefresh: function(){
                this.loading = true
                this.$store.dispatch('getAssociationDetail', {
                    associationid: 4
                }).then(d=>{
                    this.loading = false
                    this.data = d
                }).catch(error=>{
                    this.loading = false
                    this.$message.warning(error)
                })
            },
            fileViewer: function(url) {
                var left = (document.body.offsetWidth - 626) / 2
                left = left < 0 ? 0 : left
                var options = `left=${left},top=200,toolbar=0,status=0,resizable=1,width=626,height=436`
                window.open(url, 'sharer', options)
            }
        }
    }
</script>

<style lang="scss">
    .join-us {
        width: 1000px;
        margin: 0 auto;
        background-color: #fff;
    }

    .join-us h1 {
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: #212121;
        line-height: 48px;
    }

    .join-us > .content {
        margin: 0 12px;
    }

    .join-us > .content p {
        line-height: 32px;
        color: #232323;
        font-size: 16px;
        font-weight: 400;
    }

    .join-us > .content a {
        color: red;
    }

    .join-us .list-files {
        margin: 50px 12px 0px 12px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
    }

    .join-us .list-files > .file {
        margin-bottom: 20px;
        display: inline;
        display: flex;
        cursor: pointer;
        flex-direction: column;
    }

    .join-us .list-files > .file > img {
        width: 52px;
        height: 62px;
    }

    .join-us .list-files > .file > .title {
        font-size: 16px;
        font-weight: 400;
        color: #0183fc;
        line-height: 24px;
        text-decoration: underline;
    }
    
    .join-us .footer {
        height: 80px;
        width: 100%;
        background-color: #f1f1f1;
        border: 1px solid #e2e1e1;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .join-us .footer > .btn-join {
        height: 40px;
        font-size: 24px;
        color: #fff;
        background-color: tomato;
        border-radius: 12px;
        padding: 0 12px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
    }

    .join-us .footer > .btn-join:active {
        opacity: 0.7;
    }

    /** loading start */
    .lds-ring {
        display: inline-block;
        position: relative;
        width: 32px;
        height: 32px;
    }
    
    .lds-ring div {
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 24px;
        height: 24px;
        margin: 4px;
        border: 4px solid #fff;
        border-radius: 50%;
        animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
        border-color: #fff transparent transparent transparent;
    }
    
    .lds-ring div:nth-child(1) {
        animation-delay: -0.45s;
    }
    
    .lds-ring div:nth-child(2) {
        animation-delay: -0.3s;
    }
    
    .lds-ring div:nth-child(3) {
        animation-delay: -0.15s;
    }

    @keyframes lds-ring {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    /** loading end */ 

    @media only screen and (max-width: 1050px) {
        .join-us {
            width: 100%;
        }
    }
</style>
